import type { Except } from '@festina-life/core'
import type { ReactElement, ReactNode } from 'react'

import type { FormikInputPropsForWrapper } from '../types'

export const getWrapperProps = <
  Label extends string | ReactElement,
  T extends Except<
    FormikInputPropsForWrapper<Label>,
    'label' | 'existingValueConfig'
  > &
    Partial<
      Record<'defaultValue' | 'htmlFor' | 'error' | 'className', unknown>
    >,
>({
  existingValue,
  existingValueConfig: commonExistingValueConfig,
  label,
  inputValueDifferenceFromExistingValue,
  commonWrapperProps,
}: {
  commonWrapperProps: T
  label: Label | undefined
} & (
  | {
      existingValue: ReactNode
      existingValueConfig: FormikInputPropsForWrapper<Label>['existingValueConfig']
      inputValueDifferenceFromExistingValue: NonNullable<
        FormikInputPropsForWrapper<Label>['existingValueConfig']
      >['inputValueDifferenceFromExistingValue']
    }
  | {
      existingValue?: never
      existingValueConfig?: never
      inputValueDifferenceFromExistingValue?: never
    }
)) => {
  const existingValueConfig = {
    existingValue,
    inputValueDifferenceFromExistingValue,
    ...commonExistingValueConfig,
  } satisfies FormikInputPropsForWrapper<Label>['existingValueConfig']

  return {
    ...commonWrapperProps,
    existingValueConfig,
    label,
  }
}
